<template>
  <div class="atb-flex atb-flex-row atb-flex-wrap atb-justify-center atb-pt-32">
    <Card class="card-size">
      <template #body>
        <div class="atb-items-center atb-text-center atb-ml-16 atb-mr-16">
          <span class="header-font block">{{ $t('loggedOut') }}</span>
          <hr />
          <span class="text-font atb-text-center atb-mt-2 block"
            >{{ $t('logOutDescription') }}
            <a
              :href="oktaURI"
              class="hover:atb-text-blue-800 atb-text-blue-500"
              >{{ $t('identityProvider') }}</a
            ></span
          >
          <br />
          <span class="text-font atb-text-center atb-pt-4 block">{{
            $t('logBackIn')
          }}</span>
        </div>
        <div
          class="atb-flex atb-flex-row atb-justify-center atb-gap-x-8 atb-pt-4"
        >
          <Button @click="$router.push('/')"> {{ $t('login') }}</Button>
        </div>
      </template>
    </Card>
  </div>
</template>

<script lang="ts" setup>
  import Button from '@atb-ui/eds-vue/src/components/Button.vue';
  import Card from '@atb-ui/eds-vue/src/components/Card.vue';
  import { ref } from 'vue';
  const oktaURI = ref(config.VUE_APP_OKTA_URI);
</script>

<style scoped>
  .card-size {
    width: 50%;
  }

  .header-font {
    font-size: 8rem;
    font-weight: 100;
  }

  .text-font {
    font-size: 1.2rem;
  }
  .eds-card-outline {
    width: 25%;
  }
</style>
